import * as React from 'react';
import * as styles from '../Treeview.css'
import { ITreeViewItem } from '../../../interfaces/ITreeViewItem';
import { inject, observer } from 'mobx-react';
import { TreeViewStore } from '../TreeViewStore';
import "../../../styles/BasicIA.css";
import { IAIcon, IAIconProps } from '../../icon/Icon';
import { Helper } from '../../../Helper';
import { ENTER_KEY, SPACEBAR_KEY } from '../../../global/Constants';

export interface ITreeViewItemProps {
  item: ITreeViewItem;
  selectAll?: boolean;
  level: number;
  showCheckbox?: boolean;
  showIcon?: boolean;
  iconProps?: IAIconProps;
  childIsChecked?: () => void;
  onChange: () => void;
  onSelect: (item: ITreeViewItem) => void;
  treeViewStore?: TreeViewStore;
  disabled?: boolean;
  useColors?: boolean;
}

export interface ITreeViewItemState {
  expanded: boolean;
  childIsChecked: boolean;
}

@inject('treeViewStore')
@observer
export class TreeViewItem extends React.Component<ITreeViewItemProps, ITreeViewItemState> {
  private inputCheckboxRef: React.RefObject<HTMLInputElement>;

  constructor(props: ITreeViewItemProps) {
    super(props);
    this.state = {
      expanded: this.props.treeViewStore.expanded && props.level !== 2,
      childIsChecked: false
    }
    this.inputCheckboxRef = React.createRef();
  }

  public componentDidMount(): void {
    if (this.props.item.checked) {
      // this.props.childIsChecked();
    }
  }

  public render(): JSX.Element {
    let children;
    if (this.props.item.children) {
      children = this.props.item.children.map((treeViewItem: ITreeViewItem) => {
        return (
          <TreeViewItem
            key={treeViewItem.guid ? treeViewItem.guid : treeViewItem.title}
            item={treeViewItem}
            level={this.props.level + 1}
            disabled={this.props.disabled}
            childIsChecked={() => {
              this.props.item.checked = false;
              if (!this.props.item.checked && this.props.treeViewStore.areSomeChildrenButNotAllChecked(this.props.item)) {
                this.setState({ childIsChecked: true }, () => {
                  this.forceUpdate();
                  this.props.childIsChecked();
                });
              } else {
                this.setState({ childIsChecked: false }, () => {
                  this.forceUpdate();
                  this.props.childIsChecked();
                });
              }
            }}
            onChange={this.props.onChange != undefined ? () => this.props.onChange() : undefined}
            onSelect={this.props.onSelect != undefined ? (selectedTreeViewItem: ITreeViewItem) => this.props.onSelect(selectedTreeViewItem) : undefined}
            useColors={this.props.useColors}
          />
        );
      });
    }
    let backgroundColor = "#ffffff";
    let border = "1px solid #d9d9d9";
    if (this.props.treeViewStore.areSomeChildrenButNotAllChecked(this.props.item) && !this.props.item.checked) {
      backgroundColor = "transparent";
      border = `1px solid ${this.props.treeViewStore.highlightColor}`;
    }
    if (this.props.item.checked) {
      backgroundColor = this.props.treeViewStore.highlightColor;
      border = `1px solid ${this.props.treeViewStore.highlightColor}`;
    }
    return (
      <li
        className={this.state.expanded ? styles.expanded : undefined}
      // style={{
      //   fontWeight: this.props.item.children?.length > 0 ? "bold" : "unset",
      // }}
      >
        <label className={styles.IAcheckbox}>
          {this.props.treeViewStore.actionType === "Checkbox" &&
            <>
              {this.props.treeViewStore.areSomeChildrenButNotAllChecked(this.props.item) && !this.props.item.checked &&
                <div
                  className={styles.IA_checkboxSquare}
                  style={{
                    backgroundColor: this.props.treeViewStore.highlightColor
                  }}
                />
              }
              <input
                ref={this.inputCheckboxRef}
                type="checkbox"
                aria-hidden={true}
                tabIndex={-1}
                checked={this.props.item.checked}
                onChange={() => {
                  if (!this.props.disabled) {
                    let item = this.props.item;
                    item.checked = !item.checked;
                    if (item.children) {
                      this.props.treeViewStore.checkChildren(item.children, item.checked);
                    }
                    this.props.childIsChecked();
                    this.setState({ childIsChecked: false });
                    if (this.props.onChange != undefined) {
                      this.props.onChange();
                    }
                    if (this.props.onSelect != undefined) {
                      this.props.onSelect(item);
                    }
                  }
                }}
              />
            </>
          }
          {this.props.treeViewStore.actionType === "Checkbox" &&
            <div
              tabIndex={0}
              className={[styles.IAcheck, "IA_OnMouseFocusOutline"].join(" ")}
              style={{
                backgroundColor: backgroundColor,
                border: border,
                boxSizing: "border-box"
              }}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  this.inputCheckboxRef.current.click();
                }
              }}
            />
          }
          {this.props.treeViewStore.actionType === "Radio" &&
            <input
              type="radio"
              aria-label={this.props.item.title}
              checked={this.props.item.checked}
              onChange={() => {
                if (!this.props.disabled) {
                  this.props.treeViewStore.uncheckAll();
                  let item = this.props.item;
                  item.checked = !item.checked;
                  if (this.props.onChange != undefined) {
                    this.props.onChange();
                  }
                  if (this.props.onSelect != undefined) {
                    this.props.onSelect(item);
                  }
                }
              }}
            />
          }
          {this.props.treeViewStore.actionType === "Radio" &&
            <div
              className={styles.IAradio}
              style={{
                backgroundColor: backgroundColor,
                borderColor: this.props.treeViewStore.highlightColor
              }}
            />
          }
          {this.props.showIcon && this.props.iconProps &&
            <IAIcon title={this.props.iconProps.title} color={this.props.iconProps.color} size={this.props.iconProps.size} />
          }
          <div
            title={this.props.item.title ? this.props.item.title : this.props.item.name}
            className={styles.IAcaption}
            style={{
              padding: this.props.useColors ? "0px 8px" : undefined,
              borderRadius: this.props.useColors ? 5 : undefined,
              fontWeight: this.props.useColors || this.props.item?.highlighted ? "bold" : undefined,
              fontSize: this.props.useColors ? 11 : undefined,
              backgroundColor: this.props.useColors ? this.props.item?.bgColor ?? Helper.getCategoriesDefaultBackgroundColor() : undefined,
              color: this.props.useColors ? this.props.item?.textColor ?? Helper.getCategoriesDefaultTextColor() : undefined,
            }}
          >
            {this.props.item.title ? this.props.item.title : this.props.item.name}
          </div>
        </label>
        {this.props.item.children && this.props.item.children.length > 0 && this.state.expanded &&
          <ul>
            {children}
          </ul>
        }
        {this.props.item.children && this.props.item.children.length > 0 && this.props.treeViewStore.structureType === "Arrow" &&
          <div
            className={[styles.IANodetoggle, "IA_OnFocus"].join(" ")}
            tabIndex={0}
            role="button"
            aria-expanded={this.state.expanded}
            aria-label={this.props.item.title ? this.props.item.title : this.props.item.name}
            onClick={() => {
              this.setState({
                expanded: !this.state.expanded
              });
            }}
            onKeyDown={(event) => {
              if (event.key === ENTER_KEY || event.key === SPACEBAR_KEY) {
                event.preventDefault();
                this.setState({
                  expanded: !this.state.expanded
                });
              }
            }}
          />
        }
        {this.props.item.children && this.props.item.children.length > 0 && this.props.treeViewStore.structureType === "Folder" &&
          <div>
            <div
              className={[styles.IANodetoggleFolder, "IA_OnFocus"].join(" ")}
              tabIndex={0}
              role="button"
              aria-expanded={this.state.expanded}
              aria-label={this.props.item.title ? this.props.item.title : this.props.item.name}
              onClick={() => {
                this.setState({
                  expanded: !this.state.expanded
                });
              }}
              onKeyDown={(event) => {
                if (event.key === ENTER_KEY || event.key === SPACEBAR_KEY) {
                  event.preventDefault();
                  this.setState({
                    expanded: !this.state.expanded
                  });
                }
              }}
            />
            <div
              className={styles.IAicon}
              onClick={() => {
                this.setState({
                  expanded: !this.state.expanded
                });
              }}>
              <div
                style={{
                  position: "relative",
                  marginRight: "4px"
                }}>
                {!this.state.expanded &&
                  <div>
                    <svg fill="#333333" width="24" height="24" viewBox="0 0 32 32"><g><path d="M16.2,7.7h9.6v15h-20V10.2h7.9L16.2,7.7z M24.6,21.5V14h-8.4l-2.5-2.5H7.1v10H24.6z M24.6,12.7V9h-7.9l-1.9,1.9l1.9,1.9 H24.6z" /></g></svg>
                  </div>
                }
                {this.state.expanded &&
                  <div>
                    <svg fill="#333333" width="24" height="24" viewBox="0 0 32 32"><g><path d="M23.3,14h2.3l-4.4,8.7H5.8V10.2h6.6l2.5-2.5h8.4V14z M7.1,11.5v8.6l3.1-6.1h11.9V9h-6.6L13,11.5H7.1z M20.4,21.5l3.1-6.2 H10.9l-3.1,6.2H20.4z" /></g></svg>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </li>
    )
  }
}